"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react"),t=require("prop-types"),r=require("./Notification.js");function s(e){return e&&e.__esModule?e:{default:e}}var n=s(e);const o={renderNotification:s(t).default.func};class i extends e.Component{constructor(e){var t;super(e),t=this,this.shouldComponentUpdate=function(e,r){return t.props!==e},this.state={}}render(){const{index:e,renderNotification:t}=this.props,s=t||r.default;return n.default.createElement(s,Object.assign({},this.props,{disableAnimation:0!==e}))}}i.propTypes=o,exports.default=i;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/notifications/cjs/components/NotificationItem.js
// module id = 1109
// module chunks = 0